import { Component, OnInit, Input, ElementRef, ViewChild, AfterViewInit } from "@angular/core";
declare var Highcharts: any;
declare var $: any;
@Component({
  selector: "app-chart",
  templateUrl: "./chart.component.html",
  styleUrls: ["./chart.component.css"]
})
export class ChartComponent {
  @ViewChild('chartTarget') chartTarget: ElementRef;
  chartType = "bar";
  graphDataList: Array<any>;
  initialData: Array<any>;
  xAxisLabel = '';
  yAxisLabel = '';
  chartjson: any = {};
  chart: any;

  @Input()
  set chartJSON(data: any) {
    if (data) {
      this.chartjson = data;
      if(this.chartjson && this.chartjson.chart){
        this.chartType=this.chartjson.chart.type;
      }
      this.generateChart();
      if (data.chart) {
        if (data.chart.type = 'solidgauge') {
          if (data.data) {
            if (data.data.marketData) {
              let count = 0
              var point;
              setInterval(() => {
                point = this.chart.series[0].points[0];
                point.update(data.data.marketData[count].doc_count);
                if ((count + 1) < data.data.marketData.length) {
                  count = count + 1;
                } else {
                  count = 0
                }
              }, 1000);
            }
          }
        }
      }
    }
  }

  saveInstance(chartInstance): void {
    this.chart = chartInstance;
  }

  generateChart() {
    if(this.chartjson && this.chartjson.chart && this.chartjson.chart.type==="bubble"){
      Highcharts.wrap(Highcharts.Axis.prototype, "getPlotLinePath", function(
        proceed
      ) {
        var path = proceed.apply(
          this,
          Array.prototype.slice.call(arguments, 1)
        );
        if (path) {
          path.flat = false;
        }
        return path;
      });
    }
    Highcharts.setOptions({lang: {noData: "No data available"},
      chart: {
        style: {
            fontFamily: 'Montserrat-SemiBold'
        }
      }
    });
    Highcharts.SVGRenderer.prototype.symbols.download = function (x, y, w, h) {
      var path = [
        // Arrow stem
        'M', x + w * 0.5, y,
        'L', x + w * 0.5, y + h * 0.7,
        // Arrow head
        'M', x + w * 0.3, y + h * 0.5,
        'L', x + w * 0.5, y + h * 0.7,
        'L', x + w * 0.7, y + h * 0.5,
        // Box
        'M', x, y + h * 0.9,
        'L', x, y + h,
        'L', x + w, y + h,
        'L', x + w, y + h * 0.9
      ];
      return path;
    };
    this.chart = Highcharts.chart(this.chartTarget.nativeElement, this.chartjson);
  }

  download() {
    const filename = this.chartjson.title.text.split(' ').join('_');
    this.chart.exportChart({
      type: 'image/png',
      filename: filename
    });
  }

  getChartBase64() {
    return new Promise((resolve,reject) => {
      try {
        this.chart.update({
          credits: {
            text: 'www.ecosystm360.com',
            href: 'www.ecosystm360.com'
          },
        });
        var svg = this.chart.getSVG();
        var canvas = document.createElement('canvas');
        canvas.width = 1536;
        canvas.height = 768;
        var ctx = canvas.getContext('2d');
        var img = document.createElement('img');

        img.onload = function() {
            ctx.drawImage(img, 0, 0, 1536, 768);
            resolve(canvas.toDataURL('image/png'));
        };
      let  base64 = btoa(decodeURIComponent(encodeURIComponent(svg)).replace(/[\u00A0-\u2666]/g,(c)=> {
          return '&#' + c.charCodeAt(0) + ';';
      }));
      base64 = 'data:image/svg+xml;base64,' + base64;
        img.setAttribute('src', base64 );
      } catch (error) {
        reject(error);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/chart/chart.component.ts